module.exports = __webpack_public_path__ + "static/img/part_1_red.c069af80.png";